
import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Edit2 } from "lucide-react";
import { ApplicationStatus } from '@/types/application';
import { useUpdateApplicationStatus } from '@/hooks/mutations/useUpdateApplicationStatus';

interface ApplicationStatusChangerProps {
  applicationId: string;
  jobId: string;
  currentStatus: ApplicationStatus;
  candidateName?: string;
}

const availableStatuses: ApplicationStatus[] = [
  'submitted',
  'reviewing',
  'interviewing',
  'offer_extended',
  'hired',
  'rejected',
  'withdrawn',
];

export const ApplicationStatusChanger: React.FC<ApplicationStatusChangerProps> = ({
  applicationId,
  jobId,
  currentStatus,
  candidateName = "this applicant"
}) => {
  const { mutate: updateStatus, isPending } = useUpdateApplicationStatus();

  const handleStatusChange = (newStatus: ApplicationStatus) => {
    if (newStatus === currentStatus) return;
    updateStatus({ applicationId, jobId, newStatus });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" title={`Update status for ${candidateName}`} disabled={isPending}>
          <Edit2 className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {availableStatuses.map((status) => (
          <DropdownMenuItem
            key={status}
            onClick={() => handleStatusChange(status)}
            disabled={status === currentStatus || isPending}
            className={status === currentStatus ? 'bg-muted font-semibold' : ''}
          >
            {status.charAt(0).toUpperCase() + status.slice(1).replace('_', ' ')}
            {isPending && status === currentStatus && " (Updating...)"}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
